import Vue from 'vue'
import moment from '@/util/dayjs-config';
// dayjs-config ya carga 'dayjs/locale/es' + plugin relativeTime, no
// necesitamos imports adicionales aqui. moment.locale('es') ya esta
// configurado globalmente desde el modulo de config.

Vue.filter('datetime', (value) => {
  if (!value) return ''
  return moment(value).format('DD-MM-YYYY HH:mm:ss')
})
Vue.filter('speed', (value) => {
  return (parseFloat(value) * 1.852).toFixed(2) + ' Km/h';
})

Vue.filter('fromNow', (value) => {
  if (!value) return ''
  // Crear instancia con locale español explícitamente
  // locale() retorna una nueva instancia con el locale configurado
  return moment(String(value)).locale('es').fromNow()
})
